<template>
  <b-modal
      id="kbiz-account-modal"
      hide-footer
      size="xl"
      title="ลงทะเบียนระบบออโต้ KBiz"
  >
    <b-overlay :show="isFetching">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider
              v-slot="{ errors }"
              name="username"
              rules="required"
          >
            <b-form-group label="Username">
              <b-form-input
                  v-model="form.username"
                  :aria-invalid="false"
                  :state="errors[0] ? false : null"
                  name="username"
                  placeholder="ยูสเซอร์เนม KBiz"
                  type="text"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
              v-slot="{ errors }"
              name="password"
              rules="required"
          >
            <b-form-group label="Password">
              <b-form-input
                  v-model="form.password"
                  :aria-invalid="false"
                  :state="errors[0] ? false : null"
                  name="password"
                  placeholder="รหัสผ่าน KBiz"
                  type="password"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
              v-slot="{ errors }"
              name="secret-key"
              rules="required"
          >
            <b-form-group label="Secret Key">
              <b-form-input
                  v-model="form.secretKey"
                  :aria-invalid="false"
                  :state="errors[0] ? false : null"
                  name="secret-key"
                  placeholder="Secret Key"
                  type="text"
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <div class="d-flex">
            <b-button :disabled="isFetching" class="ml-auto" type="submit" variant="primary">
              ลงทะเบียน
            </b-button>
          </div>
        </form>
      </ValidationObserver>
    </b-overlay>
  </b-modal>
</template>

<script>
import Vue from 'vue';
import {mapActions} from 'vuex';

export default Vue.extend({
  name: 'KBizAccountModal',
  props: {
    agentBankAccountId: {
      type: String,
      required: true
    },
    kbizAccount: {
      type: Object,
      default: () => ({
        username: '',
        password: '',
        secretKey: '',
      })
    }
  },
  data() {
    return {
      isFetching: false,
      form: {
        username: '',
        password: '',
        secretKey: ''
      }
    }
  },
  created() {
    this.form = {
      username: this.kbizAccount?.username || '',
      password: this.kbizAccount?.password || '',
      secretKey: this.kbizAccount?.secretKey || '',
    }
  },
  methods: {
    ...mapActions(['registerKBiz', 'fetchBankAccount']),
    async onSubmit() {
      this.isFetching = true
      const response = await this.registerKBiz({ id: this.agentBankAccountId, data: this.form })
      if(response) {
        this.$bvModal.hide('kbiz-account-modal')
        await this.fetchBankAccount(this.agentBankAccountId)
      }
      this.isFetching = false
    },
  }
})
</script>

<style scoped>

</style>